module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Bold-3053fbd18c9c00d7783e462e04beed10.woff";